import { CodeEspece } from './enums/code-espece.enum';

export class GroupeVarietal {
    static jsonMap = {
        id: 'id',
        code: 'code',
        libelle: 'libelle',
        surfaceTotale: 'surfaceTotale',
        surfaceBio: 'surfaceBio',
        varietes: 'varietes',
        codeEspece: 'codeEspece'
    };

    id: number;
    code: string;
    libelle: string;
    surfaceTotale: number;
    surfaceBio: number;
    varietes: string;
    codeEspece: CodeEspece;

    toString(): string {
        return this.libelle;
    }
}
